var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bb-reject-cell"},[_c('div',{staticClass:"bb-reject-cell-icons"},[_c('img',{staticClass:"bb-reject-cell__icon",attrs:{"src":require("@/assets/images/icon-pencil.png")},on:{"click":function($event){$event.stopPropagation();return _vm.setReject($event)}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f8d14fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/BBTable/RejectCell/RejectCell.vue
// module id = null
// module chunks = 